export const TransitionValuesSeparator = "";
